import { Flex as ThemeUIFlex } from 'theme-ui';

const Flex = (props) => <ThemeUIFlex {...props}>{props.children}</ThemeUIFlex>;

export default Flex;
